<template>
  <ArlaNavbar />

  <section class="hero do-good-page">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column">
            <figure class="image">
              <img src="../assets/img/Group47@2x.png" />
            </figure>
          </div>
          <div class="column is-12">
            <!--h1 class="has-text-centered font-arla-strong-regular font-43 color-dg lh-49 has-text-centered">
              SE POKSAHTAA!
            </h1>

            <p class="arlainterface-regular font-16 mt-5">
              Poksahteleva kerrosjogurtti mehukuplilla – Arla Aamu+ Poksis on veikeä kerrosjogurtti, jossa hedelmä-
              tai marjaseoksen joukkoon on sekoitettu suussa poksahtelevia mehukuplia. Samettisen sileän luonnonjogurtin
              ja mehukuplia sisältävän hedelmäseoksen yllättävä yhdistelmä saa hymyn huulille. Lempeän luonnollisina
              makuina ovat makea mansikka, mehevä mustikka ja pirteä persikka. Verrattoman hauska makukokemus koko
              perheelle! Kuten kaikissa Arla Aamu+ jogurteissa, myös Poksiksessa makeus on vain hedelmän sokerista
              – vähemmän makeutta, mutta paljon iloa ja hauskuutta. Loppu tylsille välipaloille!
            </p-->

            <h2 class="has-text-centered font-arla-strong-regular color-dg font-30 mt-5">
              Kysely on päättynyt, Kiitos kaikille osallistumisesta
            </h2>

            <!--p class="arlainterface-regular font-16 mt-5">
              <b>Palkintoja luvassa!</b> Arvomme kyselyyn vastanneiden kesken 10 kappaletta 30 € arvoisia Arla-tuotelahjakortteja.
              Kiinnostaisiko sinua osallistua Arla Aamu+ tuotekehitykseen myös jatkossa? Laita raksi ruutuun ja saatat
              päästä osallistumaan Luonto+ tuotetestauksiin ja kuluttajatutkimuksiin. Vastauksella ei ole vaikutusta
              tämän kyselyn arvontapalkintojen voittomahdollisuuksiin.
            </p-->

          </div>
          <!--div class="column is-12 has-text-left">
            <div class="control">
              <div class="flex flex-col gap-2">
                <div class="control">
                  <label
                    class="checkbox arla-checkbox is-block ml-0 mb-2"
                  >
                    <input
                      type="checkbox"
                      v-model="participate"
                    />
                    Kyllä, haluan osallistua lahjakorttien arvontaan
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-12" v-if="participate">
            <div class="control">
              <input class="input is-large text-arla-input" type="email" placeholder="Sähköpostiosoitteesi*" v-model="email">
            </div>
          </div>

          <div class="column is-12" v-if="participate">
            <div class="control">
              <input class="input is-large text-arla-input" type="email" placeholder="Sähköpostiosoite uudelleen*" v-model="emailCheck">
            </div>
          </div>

          <div class="column is-12" v-if="participate">
            <div class="control">
              <input class="input is-large text-arla-input" type="text" placeholder="Puhelinnumero*" v-model="phone">
            </div>
          </div>

          <div class="column is-12 has-text-left">
            <div class="control">
              <div class="flex flex-col gap-2">
                <div class="control">
                  <label
                    class="checkbox arla-checkbox is-block ml-0 mb-2"
                  >
                    <input
                      type="checkbox"
                      v-model="rules"
                    />
                    Hyväksyn kyselykampanjan <span class="color-dg lottery-rules-link" @click="$refs.lotteryRulesModal.showModal()">säännöt</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-12 has-text-left">

            <p class="arlainterface-regular font-16 mt-2 mb-2">
              Minuun saa olla yhteydessä Arla Aamu+ tuotekehitykseen liittyvissä kyselyissä ja tapahtumissa
            </p>

            <div class="control">
              <label class="radio arla-radio is-block ml-0 mb-3">
                <input
                  type="radio"
                  :value="true"
                  v-model="canContactMe"
                /> Kyllä
              </label>
              <label class="radio arla-radio is-block ml-0 mb-3">
                <input
                  type="radio"
                  :value="false"
                  v-model="canContactMe"
                /> Ei
              </label>
            </div>
          </div>

          <div class="column has-text-centered">
            <button class="button arla-button" :disabled="!isFormValid" @click="submitLottery()">
              Seuraava
            </button>
          </div-->
        </div>
      </div>
    </div>
  </section>

  <ArlaFooter />
  <LotteryRulesModal ref="lotteryRulesModal" />
</template>

<script>
import ArlaNavbar from "../components/ArlaNavbar";
import ArlaFooter from "../components/ArlaFooter";
import { mapActions } from "vuex";
import LotteryRulesModal from "@/components/LotteryRulesModal";

export default {
  name: "QuestionnaireLotteryPage",
  components: {
    ArlaNavbar,
    ArlaFooter,
    LotteryRulesModal
  },
  data() {
    return {
      phone: '',
      email: '',
      emailCheck: '',
      canContactMe: false,
      participate: false,
      rules: false
    }
  },
  methods: {
    ...mapActions({
      postQuestionnaireLottery: "postQuestionnaireLottery"
    }),
    submitLottery() {
      let payload = {
        email: this.email,
        phone: this.phone,
        can_contact_me: this.canContactMe,
        submission_id: this.$route.params.userUuid
      }
      this.postQuestionnaireLottery(payload).then(() => {
        this.$router.push({ path: `/${this.$route.params.userUuid}/questionnaire` })
      })
    }
  },
  computed: {
    isFormValid() {
      if (this.participate) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.email)) {
          return false;
        }
        if (this.phone == '' || this.email == '' || this.emailCheck == '') {
          return false
        }
        return this.email == this.emailCheck && this.rules
      }
      return this.rules
    }
  }
}
</script>

<style scoped lang="scss">
@use "../assets/sass/mybulma" as *;

.do-good-page {
  flex: 1 1 auto;
}

.hero-body {
  background-color: #F6F1D3;
}

.lottery-rules-link {
  font-weight: bold;
}

.lottery-rules-link:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>